import { ReactTFC } from "../../../utils/fp/missing-ts-parts";
import React from "react";

import { CSS_COLORS } from "../../../styles/styles-css-variables";
import { CSS_MQ } from "../../../styles/breakpoints";
import { SwarovskiLink } from "../../../components/_shared-components/ui-elements/SwarovskiLink";
import { FONTS, fontSize } from "../../../styles/fonts";
import { capitalizeIfNoProductNameStyles } from "../../../styles/text-styles";
import { EXPERIMENTAL_TextWithProductNameRenderer } from "../../../domain/swarovski-optik/products/product-name/product-name-renderer";

import { css } from "@emotion/react";

export const StoryLayoutTags: ReactTFC<{
  tags: Array<{ label: string; link: { pathname: string; search: string | undefined } }>;
}> = props => {
  return (
    <ul
      css={css`
        ${CSS_MQ.atMostSm} {
          display: flex;
          flex-wrap: wrap;

          width: 100%;
          margin-bottom: 20px;

          column-gap: 12px;
          row-gap: 8px;
        }

        ${CSS_MQ.atLeastMd} {
          list-style-type: none;
          margin: 0;
          padding: 0;
          display: flex;
          flex-wrap: wrap;
        }
      `}
    >
      {props.tags.map(tag => {
        return (
          <li key={JSON.stringify(tag)} css={liStyles}>
            <SwarovskiLink
              link={tag.link}
              attachStyles={[
                FONTS.SwarovskiFutura500,
                fontSize.x2,
                capitalizeIfNoProductNameStyles,
                css`
                  color: ${CSS_COLORS.Black};
                  text-align: center;
                `,
              ]}
              isInternal={true}
              scrollToTop={true}
            >
              <EXPERIMENTAL_TextWithProductNameRenderer text={tag.label} />
            </SwarovskiLink>
          </li>
        );
      })}
    </ul>
  );
};

const liStyles = css`
  ${CSS_MQ.atLeastMd} {
    & + & {
      &:before {
        content: "";
        border-left: 2px solid black;

        padding-left: 12px;
        margin-left: 12px;

        padding-top: 4px;
      }
    }

    &:last-of-type {
      margin-right: 60px;
    }
  }
`;
